export default __webpack_public_path__ + "static/media/checkers.8bb48cb3.png";